import { Component, OnInit, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ApiService } from './../shared/api.service';
import {FormBuilder, FormGroup, Validators, FormControl, AbstractControl} from '@angular/forms';
import { TweenMax } from "gsap";
import { Negociacion } from '../shared/negociacion';
import { UploaderService } from "../shared/uploader.service";
import { DeleterService } from "../shared/deleter.service";
import * as basicLightbox from 'basiclightbox';
import * as $ from 'jquery';
import { RutService } from '../shared/rut.service';
import { ValidatorService } from '../shared/validator-service.service';
import { rutValidator, numClienteValidator } from '../shared/validator-service.service';
import { requiredFileType } from '../shared/requiredFileType.service';
import { GlobalConstants } from '../shared/global-constants';
import { NgxSpinnerService } from "ngx-spinner";
import { Title } from '@angular/platform-browser';
import { Meta, MetaDefinition } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from '../../environments/environment';
import {Observable, of, timer} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import { interval, Subscription } from 'rxjs';
import {DeviceDetectorService} from 'ngx-device-detector';
import { MatDialog } from '@angular/material/dialog';
import { ModalNumeroClientesComponent } from '../modales/modal-numero-clientes/modal-numero-clientes.component';
import { ModalPoliticaPrivacidadComponent } from '../modales/modal-politica-privacidad/modal-politica-privacidad.component';

@Component({
  selector: 'app-negociacion-comercios',
  templateUrl: './negociacion-comercios.component.html',
  styleUrls: ['./negociacion-comercios.component.scss']
})
export class NegociacionComerciosComponent implements OnInit {

  fileRutComunidad: File = null;
  fileActaReunion: File = null;
  fileCedulaIdentidad: File = null;
  fileCedulaIdentidadReverso: File = null;
  formData: FormGroup;
  submitted = false;
  pasos: any;

  respuesta: any;
  plazo: number;
  userIp: string = '';

  public mimeTypes = ValidatorService.mimeTypes;

  public dataComuna: Array<any>;
  public dataRegion: Array<any>;
  @ViewChild('comuna') comuna;

  subscription: Subscription;
  intentos = 0;

  public  spinnerMsg = '';

  infoMessage1: any;
  infoMessage2: any;
  infoMessage3: any;
  infoMessage4: any;

  tokenMessage1: any;
  tokenMessage2: any;
  tokenMessage3: any;
  tokenMessage4: any;

  errorInfoMessage1: any;
  errorInfoMessage2: any;
  errorInfoMessage3: any;
  errorInfoMessage4: any;

  file: File;
  fileName1: string = "";
  fileName2: string = "";
  fileName3: string = "";
  fileName4: string = "";
  extension1: string = "";
  extension2: string = "";
  extension3: string = "";
  extension4: string = "";
  imageUrl1: string | ArrayBuffer = "";
  imageUrl2: string | ArrayBuffer = "";
  imageUrl3: string | ArrayBuffer = "";
  imageUrl4: string | ArrayBuffer = "";

  public isBrowser = isPlatformBrowser(this.platformId);
  public isServer = isPlatformServer(this.platformId);

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private uploader: UploaderService,
    private deleter: DeleterService,
    private rutService: RutService,
    private spinner: NgxSpinnerService,
    private titleService: Title,
    private metaService: Meta,
    private recaptchaV3Service: ReCaptchaV3Service,
    @Inject(PLATFORM_ID) private platformId: any,
    private gtmService: GoogleTagManagerService,
    private deviceService: DeviceDetectorService,
    private dialog: MatDialog,
  ) {
    // PASOS DE LA VISTA
    this.pasos = [{
      "P1": {
        //*DevFun* Init
        "I": true,
        "CurrentNum": true
      },
      "P2": {
        "I": false,
        "CurrentNum": false
      },
      "P3": {
        "I": false,
        "CurrentNum": false
      }
    }]
  }

  ngAfterViewInit(){
    //@ts-ignore
    $('.videsk-top-container').css('display', 'none');
  }

  ngOnDestroy() {

    if(this.subscription)
    this.subscription.unsubscribe();

  }
  isMobile: boolean;
  ngOnInit() {

    this.isMobile = this.deviceService.isMobile();
    // CONTROLS FORMULARIO PASO 2
    this.formData = this.formBuilder.group({
      nombre: ['', [Validators.required, Validators.pattern(ValidatorService.nombre)]],
      rut: ['', [Validators.minLength(3), Validators.maxLength(12), Validators.required, rutValidator]],
      telefono: ['', [Validators.maxLength(9), Validators.pattern(ValidatorService.telefono)]],
      email: ['', [Validators.required, Validators.email, Validators.maxLength(200)]],
      nCliente: ['', [Validators.required, Validators.maxLength(9), Validators.pattern(ValidatorService.numeroCliente), numClienteValidator],[this.validarNumeroCliente.bind(this)]],
      direccion: ['', [Validators.required, Validators.pattern(ValidatorService.direccion)]],
      comuna: [{value: null, disabled: true}, [Validators.required]],
      region: [null, [Validators.required]],
      propuestas: ['', [Validators.required, Validators.maxLength(10000), Validators.pattern(ValidatorService.propuesta)]],
      fileRutComunidad: ['', [Validators.required, requiredFileType(ValidatorService.fileTypes)]],
      fileActaReunion: ['', [Validators.required, requiredFileType(ValidatorService.fileTypes)]],
      fileCedulaIdentidad: ['', [Validators.required, requiredFileType(ValidatorService.fileTypes)]],
      fileCedulaIdentidadReverso: ['', [Validators.required, requiredFileType(ValidatorService.fileTypes)]],
      terminos: [false, [Validators.requiredTrue]],
      newsletters: [false],
      privacidad: [true],
      suscripcion: [{ value: false, disabled: false }]
    });

    this.titleService.setTitle('Negociación de deuda para comunidades o comercios | Metrogas');
    this.metaService.updateTag({
      name: 'description',
      content: 'En esta sección podrás hacer una propuesta de negociación de deuda para tu comercio.'
    })

    if (this.isBrowser) {
      if (environment.production) {
        this.gtmService.addGtmToDom();
      }
      this.gotoPaso(1, null);

      this.apiService.LeerRegion().subscribe(res => {
        if (res.respuesta === true) {
          this.dataRegion = this.generarDataSetRegion(res.data);
        }
      });
    }
      // Buscar plazo
      const indice = this.apiService.configuracion.formularios.findIndex(s => s.nombre === 'Negociación de deuda para comercios');
      this.plazo = this.apiService.configuracion.formularios[indice].plazo;
      console.log('Plazo', indice, this.apiService.configuracion.formularios[indice]);
      this.getUserIp();
  }

  fileRutComunidadProgress(fileInput: any) {
    this.fileRutComunidad = <File> fileInput.target.files[0];

    let file: File;
    file = <File> fileInput.target.files[0];
    this.errorInfoMessage1 = null;
    if (file) {
      this.spinner.show();
      let fileTypes = fileInput.target.accept;
      let fileType = file.type;
      var archivoValido = (fileTypes.split(',').find(x => x === fileType) === undefined) ? false : true;

      if (archivoValido) {
        this.fileName1 = file.name;
        this.extension1 = file.name.split('.').pop().toLowerCase();
        this.file = file;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = event => {
          this.imageUrl1 = reader.result;
        };

        if (this.infoMessage1 !== null && this.infoMessage1 !== "" && this.infoMessage1 !== undefined) {
          this.deleter.delete(this.infoMessage1, this.tokenMessage1).subscribe(message => {
          });
        }
        this.infoMessage1 = null;
        this.tokenMessage1 = null;

        this.recaptchaV3Service.execute('UploadFileNegociacionComercio')
          .subscribe(
            (token) => {
              this.uploader.upload(this.file, token).subscribe(message => {
                this.infoMessage1 = message.filename;
                this.tokenMessage1 = message.token;
                this.spinner.hide();
              });
            },
            (error) => {
              this.spinner.hide();
            },
          );
      } else {
        this.infoMessage1 = null;
        this.tokenMessage1 = null;
        this.errorInfoMessage1 = "Tipo de archivo inválido";
        this.spinner.hide();
      }
    }
  }

  fileActaReunionProgress(fileInput: any) {
    this.fileActaReunion = <File> fileInput.target.files[0];

    let file: File;
    file = <File> fileInput.target.files[0];
    this.errorInfoMessage2 = null;
    if (file) {
      this.spinner.show();
      let fileTypes = fileInput.target.accept;
      let fileType = file.type;
      var archivoValido = (fileTypes.split(',').find(x => x === fileType) === undefined) ? false : true;

      if (archivoValido) {
        this.fileName2 = file.name;
        this.extension2 = file.name.split('.').pop().toLowerCase();
        this.file = file;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = event => {
          this.imageUrl2 = reader.result;
        };

        if (this.infoMessage2 !== null && this.infoMessage2 !== "" && this.infoMessage2 !== undefined) {
          this.deleter.delete(this.infoMessage2, this.tokenMessage2).subscribe(message => {
          });
        }
        this.infoMessage2 = null;
        this.tokenMessage2 = null;

        this.recaptchaV3Service.execute('UploadFileNegociacionComercio')
          .subscribe(
            (token) => {
              this.uploader.upload(this.file, token).subscribe(message => {
                this.infoMessage2 = message.filename;
                this.tokenMessage2 = message.token;
                this.spinner.hide();
              });
            },
            (error) => {
              this.spinner.hide();
            },
          );
      } else {
        this.infoMessage2 = null;
        this.tokenMessage2 = null;
        this.errorInfoMessage2 = "Tipo de archivo inválido";
        this.spinner.hide();
      }
    }
  }

  fileRutCedulaProgress(fileInput: any) {
    this.fileCedulaIdentidad = <File> fileInput.target.files[0];

    let file: File;
    file = <File> fileInput.target.files[0];
    this.errorInfoMessage3 = null;
    if (file) {
      this.spinner.show();
      let fileTypes = fileInput.target.accept;
      let fileType = file.type;
      var archivoValido = (fileTypes.split(',').find(x => x === fileType) === undefined) ? false : true;

      if (archivoValido) {
        this.fileName3 = file.name;
        this.extension3 = file.name.split('.').pop().toLowerCase();
        this.file = file;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = event => {
          this.imageUrl3 = reader.result;
        };

        if (this.infoMessage3 !== null && this.infoMessage3 !== "" && this.infoMessage3 !== undefined) {
          this.deleter.delete(this.infoMessage3, this.tokenMessage3).subscribe(message => {
          });
        }
        this.infoMessage3 = null;
        this.tokenMessage3 = null;

        this.recaptchaV3Service.execute('UploadFileNegociacionComercio')
          .subscribe(
            (token) => {
              this.uploader.upload(this.file, token).subscribe(message => {
                this.infoMessage3 = message.filename;
                this.tokenMessage3 = message.token;
                this.spinner.hide();
              });
            },
            (error) => {
              this.spinner.hide();
            },
          );
      } else {
        this.infoMessage3 = null;
        this.tokenMessage3 = null;
        this.errorInfoMessage3 = "Tipo de archivo inválido";
        this.spinner.hide();
      }
    }
  }

  fileRutCedulaReversoProgress(fileInput: any) {
    this.fileCedulaIdentidadReverso = <File> fileInput.target.files[0];

    let file: File;
    file = <File> fileInput.target.files[0];
    this.errorInfoMessage4 = null;
    if (file) {
      this.spinner.show();
      let fileTypes = fileInput.target.accept;
      let fileType = file.type;
      var archivoValido = (fileTypes.split(',').find(x => x === fileType) === undefined) ? false : true;

      if (archivoValido) {
        this.fileName4 = file.name;
        this.extension4 = file.name.split('.').pop().toLowerCase();
        this.file = file;

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = event => {
          this.imageUrl4 = reader.result;
        };

        if (this.infoMessage4 !== null && this.infoMessage4 !== "" && this.infoMessage4 !== undefined) {
          this.deleter.delete(this.infoMessage4, this.tokenMessage4).subscribe(message => {
          });
        }
        this.infoMessage4 = null;
        this.tokenMessage4 = null;

        this.recaptchaV3Service.execute('UploadFileNegociacionComercio')
          .subscribe(
            (token) => {
              this.uploader.upload(this.file, token).subscribe(message => {
                this.infoMessage4 = message.filename;
                this.tokenMessage4 = message.token;
                this.spinner.hide();
              });
            },
            (error) => {
              this.spinner.hide();
            },
          );
      } else {
        this.infoMessage4 = null;
        this.tokenMessage4 = null;
        this.errorInfoMessage4 = "Tipo de archivo inválido";
        this.spinner.hide();
      }
    }
  }

  eliminarArchivo(numero: number, fileUpload: string) {
    this.spinner.show();
    this.formData.controls[fileUpload].reset();
    if (numero === 1 && this.infoMessage1 !== null && this.infoMessage1 !== "" && this.infoMessage1 !== undefined) {
      this.deleter.delete(this.infoMessage1, this.tokenMessage1).subscribe(message => {
      });
      this.infoMessage1 = null;
      this.tokenMessage1 = null;
    } else if (numero === 2 && this.infoMessage2 !== null && this.infoMessage2 !== "" && this.infoMessage2 !== undefined) {
      this.deleter.delete(this.infoMessage2, this.tokenMessage2).subscribe(message => {
      });
      this.infoMessage2 = null;
      this.tokenMessage2 = null;
    } else if (numero === 3 && this.infoMessage3 !== null && this.infoMessage3 !== "" && this.infoMessage3 !== undefined) {
      this.deleter.delete(this.infoMessage3, this.tokenMessage3).subscribe(message => {
      });
      this.infoMessage3 = null;
      this.tokenMessage3 = null;
    } else if (numero === 4 && this.infoMessage4 !== null && this.infoMessage4 !== "" && this.infoMessage4 !== undefined) {
      this.deleter.delete(this.infoMessage4, this.tokenMessage4).subscribe(message => {
      });
      this.infoMessage4 = null;
      this.tokenMessage4 = null;
    }
    this.spinner.hide();
  }

  lightboxFile(numero: number) {
    let archivo;
    let extension;

    if (numero === 1) {
      archivo = this.imageUrl1;
      extension = this.extension1.toLowerCase();
    } else if (numero === 2) {
      archivo = this.imageUrl2;
      extension = this.extension2.toLowerCase();
    } else if (numero === 3) {
      archivo = this.imageUrl3;
      extension = this.extension3.toLowerCase();
    } else if (numero === 4) {
      archivo = this.imageUrl4;
      extension = this.extension4.toLowerCase();
    }

    const instance = basicLightbox.create(
      extension === "png" || extension === "pjp" || extension === "jpg" || extension === "pjpeg" || extension === "jpeg" || extension === "jfif" ?
        "<img class='zoom-ligthbox' src='" + archivo + "'>" :
        extension === "pdf" ?
          "<embed class='zoom-pdf' src='" + archivo + "' type='application/pdf' />" :
          extension === "doc" || extension === "docx" ?
            `"<iframe class='zoom-word' src='https://docs.google.com/gview?url=${GlobalConstants.apiResponseFile}&embedded=true'></iframe>"` :
            "<img class='zoom-ligthbox' src='" + archivo + "'>"
      , {
        closable: true
      });
    instance.show();
  }

  mostrarTerminos(objeto) {
    this.dialog.open(ModalPoliticaPrivacidadComponent);
  }

  mostrarPrivacidad(objeto) {
    this.lightboxDiv('.modal-privacidad');
  }

  mostrarSuscripcion(objeto) {
    //this.lightboxDiv('.modal-suscripcion');
  }

  mostrarNumeroCliente() {
    const dialogRef = this.dialog.open(ModalNumeroClientesComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result && result !== 'childClosed') {
        this.formData.patchValue({ nCliente: result });
      }
    });
  }

  lightboxDiv(claseCss) {
    const instance = basicLightbox.create(
      $(claseCss).get()[0].innerHTML, {
        closable: true
      });

    instance.show();
  }

  get f() {
    return this.formData.controls;
  }

  onSubmit() {
    this.spinner.show();
    this.submitted = true;
    if (this.formData.invalid) {
      this.lightboxDiv('.modal-requerido');
      this.spinner.hide();
      return;
    } else {
      this.recaptchaV3Service.execute('SubmitFileNegociacionComercio')
        .subscribe(
          (token) => {
            let negociacion = new Negociacion();
            negociacion.rut = this.formatearTextoRut(this.formData.value.rut);
            negociacion.nombre = this.formData.value.nombre;
            negociacion.telefono = this.formData.value.telefono;
            negociacion.email = this.formData.value.email;
            negociacion.numero_cliente = this.formData.value.nCliente;
            negociacion.direccion = this.formData.getRawValue().direccion;
            negociacion.id_comuna = this.formData.getRawValue().comuna;
            negociacion.id_region = this.formData.getRawValue().region;
            negociacion.propuestas = this.formData.value.propuestas;
            negociacion.archivo_rut_comunidad = this.infoMessage1;
            negociacion.archivo_acta_reunion = this.infoMessage2;
            negociacion.archivo_cedula_identidad = this.infoMessage3;
            negociacion.archivo_cedula_identidad_reverso = this.infoMessage4;
            //negociacion.acepto_condiciones = this.formData.value.terminos === null ? false : this.formData.value.terminos;
            negociacion.acepto_newsletters = this.formData.value.newsletters === null ? false : this.formData.value.newsletters;
            negociacion.acepto_privacidad = this.formData.value.terminos === null ? false : this.formData.value.terminos;
            negociacion.acepto_suscripcion = this.formData.value.suscripcion === null ? false : this.formData.value.suscripcion;
            negociacion.token = token;
            negociacion.ip = this.userIp;
            const formulario = new FormData();
            formulario.append("data", JSON.stringify(negociacion));

            this.apiService.AgregarNegociacionComercio(formulario, negociacion).subscribe(res => {
              if (res.respuesta === true) {
                // Acá se muestra la respuesta de la solicitud y se debe procesar
                this.spinnerMsg = GlobalConstants.mjeEspera;
                this.gotoPaso(3, res);
              }
              else {
                this.lightboxDiv('.modal-error');
                this.spinner.hide();
              }
            });
          },
          (error) => {
            this.lightboxDiv('.modal-error');
            this.spinner.hide();
          },
        );
    }
  }

  onReset() {
    this.submitted = false;
    this.formData.reset();
  }

  formatearRut(objeto) {
    objeto.target.value = this.rutService.transform(objeto.target.value);
  }

  formatearTextoRut(texto) {
    return (texto === null || texto === undefined) ? "" : this.rutService.transform(texto);
  }

  gotoPaso(index, respuesta) {
    switch (index) {
      case 1:
        this.pasos[0]['P1'].I = true;
        this.pasos[0]['P2'].I = false;
        this.pasos[0]['P3'].I = false;
        TweenMax.to('.linea-current', 0.5, {
          width: '50%', onComplete: () => {
            this.pasos[0]['P1'].CurrentNum = true;
            this.pasos[0]['P2'].CurrentNum = false;
            this.pasos[0]['P3'].CurrentNum = false;
            $(".paso-1")[0].scrollIntoView();
          }
        });
        break;
      case 2:
        this.pasos[0]['P1'].I = false;
        this.pasos[0]['P2'].I = true;
        this.pasos[0]['P3'].I = false;
        TweenMax.to('.linea-current', 0.5, {
          width: '50%', onComplete: () => {
            this.pasos[0]['P1'].CurrentNum = true;
            this.pasos[0]['P2'].CurrentNum = true;
            this.pasos[0]['P3'].CurrentNum = false;
            $(".paso-2")[0].scrollIntoView();
          }
        });
        break;
        case 3:
          this.spinner.show();
          const source = interval(2000);
          this.subscription = source.subscribe(val => {
            this.apiService.LeerAviso(respuesta.idTransaccion).subscribe( aviso => {
              let CodigoAprovacion = aviso.Mensajes.item[0].CodMensaje;
              let nombre = this.formData.value.nombre;
              let mail = this.formData.value.email;
              let codigo = aviso.NumAviso
              if (CodigoAprovacion === "000" || CodigoAprovacion === "002") {
                this.sendEmail(nombre ,mail, codigo );
              }
              if( aviso != null && aviso !== 'null'){
                 this.subscription.unsubscribe();
                 this.gotoPaso(4, aviso);
                 this.spinner.hide();
                 this.intentos = 0;
              }
              else if ( this.intentos >= GlobalConstants.reintentosSolicitud){
                this.lightboxDiv('.modal-error');
                this.subscription.unsubscribe();
                this.spinner.hide();
                this.intentos = 0;
              }else{
                this.intentos++;
              }
            },
            err => {
              console.log('ERROR: ' + err);
            }
            );
          });
          break;
      case 4:
        // Acá se debe procesar la respuesta y mandarla al componente <app-solicitud-recibida>
        this.pasos[0]['P1'].I = false;
        this.pasos[0]['P2'].I = false;
        this.pasos[0]['P3'].I = true;
        this.respuesta = respuesta;
        $("app-boleta").show();
        TweenMax.to('.linea-current', 1, {
          width: '100%', onComplete: () => {
            this.pasos[0]['P1'].CurrentNum = true;
            this.pasos[0]['P2'].CurrentNum = true;
            this.pasos[0]['P3'].CurrentNum = true;
            $(".paso-3")[0].scrollIntoView();
          }
        });
        break;
    }
  }

  sendEmail(nombre: string, mail: string, requestId: string) {
    this.apiService.sendEmail(nombre, mail, requestId).subscribe(
        response => {
        //console.log('Email Enviado', response);
      },
      error => {
        console.error('Error enviando email', error);
      }
    );
  }

  onChangeRegion(obj) {
    this.spinner.show();
    if (obj) {
      this.apiService.LeerComunaRegion(obj.id_region).subscribe(res => {
        if (res.respuesta === true) {
          this.dataComuna = this.generarDataSetComuna(res.data);
          this.comuna.handleClearClick();
        }
        this.spinner.hide();
      });
    } else {
      this.comuna.handleClearClick();
      this.spinner.hide();
    }
  }

  generarDataSetComuna(data: any) {
    data.forEach(element => {
      element.id = element.id_comuna;
    });
    return data;
  }

  generarDataSetRegion(data: any) {
    data.forEach(element => {
      element.id = element.id_region;
    });
    return data;
  }

   validarNumeroCliente(
    control: AbstractControl
  ): Observable<{ [key: string]: any } | null> {
    if (control.value === null || control.value.length === 0) {
      return of(null);
    } else {
      this.spinner.show();
      return timer(0).pipe(
        switchMap(() => {
          return this.apiService.checkCliente(control.value).pipe(
            map(res => {
              if (res.respuesta) {

                this.formData.patchValue({
                  direccion: res.ConsultarDireccionClientePorCtaCtoResponse.Direccion,
                  region: parseInt( res.ConsultarDireccionClientePorCtaCtoResponse.Region, 10),
                  comuna: res.ConsultarDireccionClientePorCtaCtoResponse.Comuna

                });
                this.formData.controls.direccion.disable();
                this.formData.controls.region.disable();
                this.formData.controls.comuna.disable();
                this.spinner.hide();
                return null;
              }else{
                this.lightboxDiv('.modal-error-cliente');
              }
              // SI ES INCORRECTO LIMPIAR
              this.formData.patchValue({
                direccion: null,
                region: null,
                comuna: null

              });

              this.formData.controls.direccion.enable();
              this.formData.controls.region.enable();
              this.formData.controls.comuna.enable();
              this.spinner.hide();
              return { numClienteExist: true };
            })
          );
        })
      );
    }
  }

  onSuscripcionChange(event) {
    let clientId = this.formData.value.nCliente;
    
    if (clientId === "") {
      alert(
        'Es necesario ingresar su número de cliente.'
      );
      this.formData.patchValue({
        suscripcion: false
      });
    } else {
      this.apiService.ConsultaSuscripcionBoletaElectronicaIC(clientId).subscribe((response: any) => {
        console.log("responce de boleta electronica", response)
        // Si retorna un NO, se levanta POPUP de alerta
        if (response.Indicador == "NO" || response.TipoTarifa == "Null") {
          this.formData.patchValue({
            suscripcion: false
          });
          this.formData.get('suscripcion').disable();
          alert(
            'Estimado cliente, la suscripción electrónica no es factible para este número de cliente.'
          );
        }
      });
    }
  }

  getTextClass() {
    return { 'disabled-text': this.formData.get('suscripcion').disabled };
  }

  getCheckboxClass() {
    return { 'disabled-checkbox': this.formData.get('suscripcion').disabled };
  }

  getUserIp(): void {
  fetch('https://api.ipify.org?format=json')
    .then(response => response.json())
    .then(data => {
      this.userIp = data.ip;
    })
    .catch(error => {
      this.userIp = '';
    });
  }
}
